import { uploadFile } from '@/lib/upload-file';

// Uploads a social-post image to S3 via the presigned-URL flow and returns the
// public, hosted file URL to store as the post's `image_url`.
//
// Regression: GitHub issue #141 — the Social Media Post Creator converted the
// selected file to a base64 `data:` URL and sent that as `image_url`. The
// backend validates `image_url` with `@IsUrl()` (which rejects `data:` URLs),
// so publishing failed with 400 in production; and Instagram/Facebook can only
// fetch a hosted URL, never a base64 blob. This performs the real S3 upload
// (mirroring the product/logo image flow) and returns the hosted URL.

export async function uploadSocialImage(
  file: File,
  fetchImpl: typeof fetch = fetch,
): Promise<string> {
  const { file_url } = await uploadFile(file, 'social-media', fetchImpl);
  return file_url;
}
